/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useState } from "react";
import { HeaderTopBar } from "./header-top-bar";
import { HeaderNavBar } from "./header-nav-bar";
import { HeaderMenuMobile } from "./header-menu-mobile";

const ServicesHeader = () => {

    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const toggleMobile = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    return (
        <header>
            <HeaderTopBar toggleMobile={toggleMobile}/>
            <HeaderNavBar />
            <HeaderMenuMobile show={showMobileMenu} />
        </header>
    );
};

export { ServicesHeader };
